import styled from "styled-components";
import { CommonButton, CommonInput } from "../../common-styles";

const MOBILE_BOTTOM_NAV_CLEARANCE = "calc(6.75rem + env(safe-area-inset-bottom, 0px))";

interface UserListProp {
  showUserList: boolean;
}

interface MessageShaderProp {
  isVisible: boolean;
  isMobile: boolean;
}

export const MessageWrapper = styled.div`
  padding: 1rem;
  padding-left: 0;
  background-color: #000000;
  padding-bottom: 0;

  @media screen and (max-width: 800px) {
    padding: 1rem;
    padding-bottom: ${MOBILE_BOTTOM_NAV_CLEARANCE};
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
`;

export const MessageHeading = styled.h1`
  display: flex;
  align-items: center;
  gap: 1rem;

  span {
    font-size: 1.2rem;
    font-weight: 400;
  }

  .menu-icon {
    display: none;
    cursor: pointer;
    @media screen and (max-width: 800px) {
      display: block;
    }
  }
`;

export const MessageContainer = styled.div`
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100%;
  height: calc(100vh - 58px);
  display: flex;

  @media screen and (max-width: 768px) {
    flex: 1 1 auto;
    height: auto;
    min-height: 0;
    padding-bottom: 0;
  }
`;

export const UserListWrallper = styled.div<UserListProp>`
  width: 320px;
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media screen and (max-width: 768px) {
    position: fixed;
    width: 100vw;
    z-index: 20;
    background-color: #000000;
    height: 100svh;
    height: 100dvh;
    box-sizing: border-box;
    top: 0;
    left: 0;
    transform: translateX(${({ showUserList }) => showUserList ? "0px" : "-100%"});
    align-items: center;
    justify-content: flex-start;
    padding: 2.5rem 0 calc(7.75rem + env(safe-area-inset-bottom, 0px)) 0;
    scroll-padding-top: 2.5rem;
    scroll-padding-bottom: calc(7.75rem + env(safe-area-inset-bottom, 0px));
  }
`;

export const MessageShader = styled.div<MessageShaderProp>`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 10;
  width: ${({ isMobile }) => (isMobile ? 0 : "30%")};
  height: 100vh;
  background-color: #000;
  transition: 0.3s;
  display: none;

  @media screen and (max-width: 800px) {
    display: block;
    opacity: ${({ isVisible }) => (isVisible ? 0.5 : 0)};
    pointer-events: ${({ isVisible }) => (isVisible ? "all" : "none")};
  }
`;

export const SubscribeButton = styled.button`
  background: #000000;
  padding: 0.5rem 2rem;
  color: #ffffff;
  border-radius: 50px;
  border: 1px solid white;
  font-size: 15px;
`;

export const SubscribeBox = styled.div`
  height: 60px;
  width: calc(100% - (2rem + 10px));
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid white;
  margin-left: 1rem;
  margin-bottom: 0.5rem;
`;

export const MessagesWrapper = styled.div`
  flex: 1;
  color: white;
  overflow: auto;
  margin-bottom: 0.5rem;
  min-height: 0;
  -webkit-overflow-scrolling: touch;

  @media screen and (max-width: 768px) {
    margin-bottom: 0.75rem;
    scroll-padding-bottom: 1rem;
  }
`;

export const MessageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.5rem;
  position: sticky;
  top: 0;
  z-index: 10;
  background: #000000;

  @media screen and (max-width: 768px) {
    button {
      padding: 0.5rem;
      span {
        display: none;
      }
    }
  }
`;

export const NewMessageButton = styled(CommonButton)`
  padding: 0.5rem 1rem;
  color: rgb(255 255 255 / 70%);
  background: #000000;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.7);

  &:hover {
    color: white;
    background-color: #000000;
  }
`;

export const MessageActionWrapper = styled.form<{ isMobile?: boolean }>`
  padding: 0 0.8rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: white;
  border-radius: 5px;
  margin-left: ${(props) => (props.isMobile ? 0 : "1rem")};
  overflow: hidden;

  @media screen and (max-width: 768px) {
    flex: none;
    position: fixed;
    left: 1rem;
    right: 1rem;
    bottom: calc(50px + env(safe-area-inset-bottom, 0px));
    z-index: 5;
    margin: 0;
    padding: 0.15rem 0.7rem;
  }
`;

export const NewMessage = styled(CommonInput)`
  flex: 1;
  background-color: transparent;
  height: unset;
  padding: 0.8rem 0;
  font-size: 16px;
  border-radius: 7px;
  border: none;
  color: black;
  font-family: "Noto Sans", sans-serif;
  opacity: 1;

  &::placeholder {
    color: #767676;
  }
`;

export const MessageActionBtn = styled.button<{
  bgcolor?: string;
  color?: string;
}>`
  background-color: ${(props) => props.bgcolor ?? "#fff"};
  color: ${(props) => props.color ?? "#2F80ED"};
  width: 40px;
  height: 40px;
  aspect-ratio: 1/1;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;

  .button-icon {
    font-size: 1.6rem;
  }
`;

export const MessageBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const UserListTools = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  position: sticky;
  top: 0;
  background-color: #000000;

  p,
  svg {
    color: rgb(255, 255, 255, 0.7);
  }

  svg {
    cursor: pointer;
  }

  @media screen and (max-width: 800px) {
    padding: 1rem;
  }
`;

export const SeletedChatUser = styled.h1`
  color: white;
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-left: 1.5rem;
  padding-bottom: 0.45rem;
`;

export const SelectedChatIdentity = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const SelectedChatName = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.15;
`;

export const CreatorPresenceStatus = styled.div<{ $online: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  color: ${({ $online }) => ($online ? "#34d399" : "rgba(255, 255, 255, 0.48)")};
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.2;
  margin-top: 0.2rem;

  > span {
    width: 7px;
    height: 7px;
    border-radius: 999px;
    background: ${({ $online }) => ($online ? "#22c55e" : "rgba(255, 255, 255, 0.3)")};
    box-shadow: ${({ $online }) =>
      $online ? "0 0 0 2px rgba(34, 197, 94, 0.14)" : "none"};
  }
`;

export const PaymentModalWrapper = styled.div`
  color: white;
`;

export const UserImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #ffffff;
  object-fit: cover;
  flex: none;
`;

export const MessageSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 420px;

  @media screen and (max-width: 768px) {
    min-height: 0;
    height: 100%;
    padding-bottom: 5rem;
  }
`;

export const EmptyMessageMainPanel = styled.div`
  flex: 1;
  min-height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 769px) {
    .lottie-player {
      width: 220px !important;
      height: 220px !important;
      margin-bottom: 36px;
    }

    div {
      font-size: 22px !important;
      letter-spacing: 0.01em;
    }
  }
`;

export const MobileEmptyStateWrapper = styled.div`
  flex: 1;
  width: 100vw;
  min-height: 100vh;
  background: #101014;
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    width: 100%;
  }

  @media (min-width: 769px) {
    display: none;
  }
`;
